import React, { } from 'react';
import './../../assets/styles/Footer.css'
import logoSvg from './../../assets/images/new/logo.webp'
import GraviolaDigitalSvg from './../../assets/images/new/graviola-digital-logo.svg'
import Button from "../button";

const Footer = ({ ignoreLogo = false, ...props }) => {
    return (
        <div id="footer" className={`footer_container w-full max-w-md mx-auto shadow-lg bg-white`}>
            <Button onClick={props.openAboutModal}>
                Sobre Nós
            </Button>

            <Button onClick={props.openQuestionsModal}>
                Dúvidas
            </Button>

            <Button onClick={props.openContactUsModal}>
                Fale conosco
            </Button>


            {!ignoreLogo ? <div className="footer_box" style={{ backgroundImage: `url(${logoSvg})` }} /> : null}

            <div className="graviola_logo" style={{ backgroundImage: `url(${GraviolaDigitalSvg})` }} />
            {/* <p>
                &copy; Copyright Graviola Digital {new Date().getFullYear()}<br />Todos direitos reservados.
            </p> */}
            <p className='text-center text-pallet-1'>&copy; Copyright Graviola Digital {new Date().getFullYear()} <br /> Todos os direitos reservados.</p>
        </div>
    );
}

export const handleClick = event => {
    // window.open('www.google.com', '_blank')
}

export default Footer;
